import { CustomPortal } from '~/commonComponents/CustomPortal/CustomPortal';

interface IPaymentSuccessPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaymentSuccessPopup = ({ isOpen, onClose }: IPaymentSuccessPopupProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <CustomPortal
      title="Payment Processed Successfully!"
      text="You're all set! Your payment was successful and your jobs are active again. Make sure onsite interviews are posted to start getting candidates."
      submitPressed={onClose}
      isSuccess
      buttonText="Close"
      redirect={false}
      popupProps={{
        dismissiblePopup: false,
        showClosePopupIcon: false,
      }}
    />
  );
};
